/**
 * Console filtering for production builds
 * Suppresses expected API errors from appearing in production console
 */

// Only apply filtering in production
if (import.meta.env.PROD) {
    // Store original console methods
    const originalError = console.error;
    const originalWarn = console.warn;

    // List of error patterns to suppress in production
    const suppressPatterns = [
        /bedrock-invocations/i,
        /supabase\.co\/functions/i,
        /Failed to load resource/i,
        /the server responded with a status of 500/i,
        /the server responded with a status of 400/i
    ];

    // Check if error message matches any suppress pattern
    const shouldSuppress = (message) => {
        const messageStr = String(message);
        return suppressPatterns.some(pattern => pattern.test(messageStr));
    };

    // Override console.error
    console.error = (...args) => {
        // Check if any argument matches suppression patterns
        const shouldSuppressError = args.some(arg => shouldSuppress(arg));

        if (!shouldSuppressError) {
            originalError.apply(console, args);
        }
    };

    // Override console.warn
    console.warn = (...args) => {
        // Check if any argument matches suppression patterns
        const shouldSuppressWarn = args.some(arg => shouldSuppress(arg));

        if (!shouldSuppressWarn) {
            originalWarn.apply(console, args);
        }
    };
}

// For development, leave console as-is for debugging
export default {};
